export const SET_FILTERS = "SET_FILTERS";



// WEBPACK FOOTER //
// ./src/services/filters/types.js